var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b50iworxca)",
    fill: "#777F95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.276 14.12-3.347-2.51V6.497a.929.929 0 1 0-1.859 0v5.577c0 .293.138.57.372.744l3.718 2.789a.924.924 0 0 0 .557.186.922.922 0 0 0 .745-.373.928.928 0 0 0-.186-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm0 22.141c-5.591 0-10.141-4.55-10.141-10.141S6.409 1.859 12 1.859c5.592 0 10.141 4.55 10.141 10.141S17.591 22.141 12 22.141z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b50iworxca"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock1);
export default __webpack_public_path__ + "static/media/icon-clock-1.54f93fc4bf3e11a1ba6ff36d9c5daa23.svg";
export { ForwardRef as ReactComponent };